module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/commons/templates/calendar/CalendarList.ejs -->\n<div class="calendar-list">\n    <table class="footable table table-striped">\n        <thead>\n            <tr>\n                <th>Location</th>\n                <th width="35%">Name</th>\n                <th>Leave type</th>\n                <th>Leave start</th>\n                <th>Leave end</th>\n                <th>Status</th>\n            </tr>\n        </thead>\n        <tbody>\n            ';
 if (leaveRequests.length === 0) { 
__p+='\n                <tr class="table-no-entries">\n                    <td colspan="6">\n                        <h2>There are currently no leave requested</h2>\n                    </td>\n                </tr>\n            ';
 } 
__p+='\n        </tbody>\n    </table>\n</div>\n\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/commons/templates/calendar/CalendarList.ejs
// module id = 902
// module chunks = 1